import { useQuery } from '@tanstack/react-query'
import { learnerDiagnosticsApi } from '@/api/learnerDiagnostics'

export const pendingDiagnosticKey = ['learner', 'me', 'pending-diagnostic'] as const

export interface UsePendingDiagnosticOptions {
  pollInterval?: number
  enabled?: boolean
}

export function usePendingDiagnostic(options: UsePendingDiagnosticOptions = {}) {
  const { pollInterval, enabled = true } = options
  return useQuery({
    queryKey: pendingDiagnosticKey,
    queryFn: async () => {
      const res = await learnerDiagnosticsApi.getMine()
      return res.data.data
    },
    enabled,
    staleTime: 0,
    refetchInterval: pollInterval && pollInterval > 0 ? pollInterval : false,
    refetchOnWindowFocus: pollInterval ? true : false,
  })
}
